<div class="automations-dialog-container">
  <!-- Header -->
  <div class="dialog-header">
    <ui-headline
      type="h18"
      mobile-type="h18"
      font-weight="semibold"
      text-color="neutrals-900"
      content="Automatizaciones"
    />
    <button class="close-button" (click)="closeModal()">
      <ui-icon name="x" fill="neutrals-600" m-size="24" size="24" />
    </button>
  </div>

  <!-- Content -->
  <div class="dialog-content">
    <!-- Section Title -->
    <div class="section-header">
      <ui-headline
        type="h16"
        mobile-type="h16"
        font-weight="semibold"
        text-color="neutrals-900"
        content="Archivado automático por inactividad"
      />
      <ui-paragraph
        type="p14"
        mobile-type="p14"
        text-color="neutrals-600"
        content="Selecciona cuánto tiempo debe transcurrir sin actividad antes de que un lead se archive automáticamente"
      />
    </div>

    <!-- Loading State -->
    <div *ngIf="isLoadingOptions" class="loading-container">
      <ngx-skeleton-loader
        count="3"
        appearance="line"
        [theme]="{ height: '56px', marginBottom: '12px' }"
      />
    </div>

    <!-- Options List -->
    <div *ngIf="!isLoadingOptions" class="options-container">
      <div
        *ngFor="let option of archiveTimeoutOptions"
        class="option-item"
        [class.option-disabled]="isSaving"
      >
        <div class="option-content">
          <div class="option-text">
            <ui-headline
              type="h14"
              mobile-type="h14"
              font-weight="medium"
              text-color="neutrals-900"
              [content]="option.description"
            />
          </div>
          <div class="option-toggle">
            <label class="toggle-switch">
              <input
                type="checkbox"
                [checked]="isTimeoutSelected(option.id)"
                [disabled]="isSaving"
                (click)="onTimeoutClick($event, option.id)"
              />
              <span class="toggle-slider"></span>
            </label>
          </div>
        </div>
      </div>

      <!-- Status Messages -->
      <div
        *ngIf="isSaving || saveMessage"
        class="status-message"
        [class.status-success]="saveMessageType === 'success'"
        [class.status-error]="saveMessageType === 'error'"
        [class.status-saving]="isSaving"
      >
        <ui-paragraph
          type="p12"
          mobile-type="p12"
          [text-color]="
            saveMessageType === 'success'
              ? 'success-600'
              : saveMessageType === 'error'
                ? 'error-600'
                : 'neutrals-600'
          "
          [content]="isSaving ? 'Guardando configuración...' : saveMessage"
        />
      </div>
    </div>
  </div>
</div>
